import { Skeleton } from '@/components/ui/skeleton';

export const ControlListSkeleton = () => {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <Skeleton className="h-4 w-48" />
        <div className="flex space-x-2">
          <Skeleton className="h-9 w-24" />
          <Skeleton className="h-9 w-24" />
        </div>
      </div>
      
      <div className="rounded-md border">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b">
                <th className="h-12 px-4 text-left align-middle">
                  <Skeleton className="h-4 w-4" />
                </th>
                <th className="h-12 px-4 text-left align-middle">
                  <Skeleton className="h-4 w-32" />
                </th>
                <th className="h-12 px-4 text-left align-middle">
                  <Skeleton className="h-4 w-24" />
                </th>
                <th className="h-12 px-4 text-left align-middle">
                  <Skeleton className="h-4 w-20" />
                </th>
                <th className="h-12 px-4 text-left align-middle">
                  <Skeleton className="h-4 w-28" />
                </th>
              </tr>
            </thead>
            <tbody>
              {[...Array(5)].map((_, i) => (
                <tr key={i} className="border-b">
                  <td className="p-4 align-middle">
                    <Skeleton className="h-4 w-4" />
                  </td>
                  <td className="p-4 align-middle">
                    <Skeleton className="h-5 w-48" />
                    <Skeleton className="h-4 w-64 mt-1" />
                  </td>
                  <td className="p-4 align-middle">
                    <Skeleton className="h-4 w-32" />
                  </td>
                  <td className="p-4 align-middle">
                    <Skeleton className="h-6 w-20 rounded-full" />
                  </td>
                  <td className="p-4 align-middle">
                    <Skeleton className="h-4 w-24" />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export const SearchBarSkeleton = () => (
  <div className="space-y-2">
    <Skeleton className="h-10 w-full max-w-md" />
  </div>
);

export const TabsSkeleton = () => (
  <div className="flex space-x-2">
    {[...Array(5)].map((_, i) => (
      <Skeleton key={i} className="h-10 w-20" />
    ))}
  </div>
);

export const ActionBarSkeleton = () => (
  <div className="flex items-center justify-between p-2 bg-muted/40 rounded-md">
    <Skeleton className="h-6 w-32" />
    <div className="flex space-x-2">
      <Skeleton className="h-9 w-24" />
      <Skeleton className="h-9 w-24" />
      <Skeleton className="h-9 w-24" />
    </div>
  </div>
);

export const FullPageSkeleton = () => (
  <div className="container mx-auto p-6 space-y-6">
    <div className="flex items-center justify-between">
      <div className="space-y-2">
        <Skeleton className="h-8 w-64" />
        <Skeleton className="h-4 w-96" />
      </div>
      <div className="flex space-x-2">
        <Skeleton className="h-9 w-24" />
        <Skeleton className="h-9 w-32" />
      </div>
    </div>
    
    <div className="space-y-4">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
        <SearchBarSkeleton />
        <TabsSkeleton />
      </div>
      
      <ActionBarSkeleton />
      <ControlListSkeleton />
    </div>
  </div>
);

export default {
  ControlList: ControlListSkeleton,
  SearchBar: SearchBarSkeleton,
  Tabs: TabsSkeleton,
  ActionBar: ActionBarSkeleton,
  FullPage: FullPageSkeleton,
};
